<template>
  <div id="app">
    <div v-if="(wording && wording.length > 0) && (submissions && submissions.length)">
      <div class="container-fluid ">
        <div class="row">
          <div class="col col-sm-4 offset-sm-1 mt-2">
            <img src="./assets/img/banner_left.jpg" class="img-fluid float-left" height="100%">
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col col-sm-6">
            <h1 class="ml-auto my-auto text-primary font-weight-bold text-sm-right mt-2" v-html="getTitle()"></h1>
          </div>
        </div>
      </div>
      <div class="bg-transparent border-bottom-2 border-danger">
        <nav class="col-10 offset-1 navbar navbar-expand-lg navbar-light pb-0 pl-2 pr-2">
          <ul class="navbar-nav mr-auto mt-lg-0" v-if="login.success === false">
            <li class="nav-item">
              <router-link class="nav-link" to="/login">
                <icon :icon="['fad', 'sign-in-alt']"/>
                Login
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav mr-auto mt-lg-0" v-if="login.success">
            <li class="nav-item">
              <router-link class="nav-link" to="/home">
                <icon :icon="['fad', 'home']"/>
                {{wording[0].navigation.home}}
              </router-link>
            </li>
          </ul>
          <ul class="navbar-nav nav-pills" v-if="login.success">
            <li class="nav-item">
              <a class="nav-link" :href="getAccountUrl()">
                <icon :icon="['fad', 'id-badge']"/>
                {{wording[0].navigation.account}}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" v-on:click="logout()">
                <icon :icon="['fad', 'sign-out-alt']"/>
                {{wording[0].navigation.logout}}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="border-bottom border-dark bg-primary d-flex sticky-top">
        <div class="col-10 offset-1 pl-1 pr-1 mx-auto" id="submenu">
          <submission-steps v-if="$route.path.includes('/abstract/')"/>
          <general-navigation v-else></general-navigation>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row" style="min-height: 350px;">
          <div class="col col-lg-10 offset-lg-1 mt-2" v-if="submissions && submissions.length > 0">
            <router-view/>
          </div>
          <div class="col col-lg-10 offset-lg-1 mt-2 text-center" v-else>
            <Loader></Loader>
            Please wait while your submissions are loaded.
          </div>
        </div>
      </div>
      <div class="text-center pt-1 mt-2 pb-1 border-top">
        designed by&nbsp;
        <a href="https://documedias.com" target="_blank"><img src="./assets/img/documedias_logo.png" class="img-fluid"
                                                              style="height: 20px;"></a>
        <br>
        <div class="small">
          <a href="https://www.abstractserver.com/datenschutz/imprint.html#eng" target="_blank"
             class="">Imprint</a> - <a
          href="https://www.abstractserver.com/datenschutz/data_security_agreement.html#eng" target="_blank"
          class="">Data Security
          Agreement</a>
        </div>
      </div>
    </div>
    <Loader v-else></Loader>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import GeneralNavigation from "./views/navbars/GeneralNavigation";
  import SubmissionSteps from "./views/navbars/SubmissionSteps";
  import Loader from './components/Loader';

  export default {
    components: {GeneralNavigation, SubmissionSteps, Loader},
    computed: mapState([
      'abstracts', 'login', 'submissions', 'language', 'wording'
    ]),
    mounted() {
      this.$store.dispatch('GET_ALL_STATUS');
      this.$store.dispatch('GET_ALL_TYPES');
      this.$store.dispatch('GET_ALL_SUBMISSIONS');
      this.$store.dispatch('GET_ALL_PAGES');
      this.$store.dispatch('GET_ALL_COUNTRIES');
      this.$store.dispatch('GET_ALL_WORDING', this.language);

      if (this.login.success === false) {
        this.$router.push('/login');
      }
    },
    methods: {
      getTitle() {
        return process.env.VUE_APP_TITLE
      },
      logout() {
        this.login.success = false;
        localStorage.removeItem('x-api-key');
        this.$router.push('/login');

      },
      changeLanguage(language) {
        this.$store.dispatch('GET_ALL_WORDING', language);
      },

    }
  }
</script>

<style lang="scss">
  @import './assets/styles/custom-bootstrap.scss';
  @import './assets/styles/radial_progress.scss';
  @import "~bootstrap/scss/bootstrap";
</style>
